import axios from "lib/axios";

export const fetchBuildingsApi = async () => {
  return await axios.get('/minutes/buildings');
};

